import React from 'react';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, AppBar, Toolbar, IconButton } from '@mui/material';
import { Theme } from '@mui/material';
// components
import MHidden from '../components/@material-extend/MHidden';
import AccountPopover from './AccountPopover';
import ClientSelectorPopover from './ClientSelectorPopover';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useLocation } from "react-router-dom";
import useLocalStorage from '../hooks/useLocalStorage';
import { BackendData } from "../Common/Utils/backendDataParser";
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import { useSelector } from 'react-redux';
import { AppState } from '../Common/Reducer/rootReducerTypes';
import { SmallTalkPermission } from '../Common/enums';
import { getPermissions } from '../utils/userInfoKeyValuePairChecker';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
  }
}));

// ----------------------------------------------------------------------

type NavbarProps = {
  onOpenSidebar: VoidFunction;
};

export default function Navbar({ onOpenSidebar }: NavbarProps) {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const location = useLocation();
  const [clients] = useLocalStorage<BackendData[]>('clientOptions', []);

  const shouldShowClientSelector = clients.length > 1 ? true : false;

  const userInfo = useSelector((state: AppState) => state.userInfo.userInformation);
  const smallTalkPermissions: Array<SmallTalkPermission> = getPermissions(userInfo.userPermissions, 'smallTalkPermissions');

  const hasPermissionToShowMessages = smallTalkPermissions !== null && smallTalkPermissions.includes(SmallTalkPermission.show_messages)
        && smallTalkPermissions.includes(SmallTalkPermission.view_identity_customers);

  const handleBackClick = () => {
    navigate(-1);
  }

  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} style={{
            marginRight: theme.spacing(1),
            color: theme.palette.text.primary
          }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
        {
          location.pathname !== '/' &&
          location.pathname !== '/orderlist' &&
          location.pathname !== '/assetlist' &&
          location.pathname !== '/companies' &&
          location.pathname !== '/users' &&
          location.pathname !== '/permissions' &&
          location.pathname !== '/quotelist' &&
          <IconButton onClick={handleBackClick} style={{ marginLeft: 'auto', opacity: '0.5' }}>
            <ArrowBack color="primary" />
          </IconButton>
        }
        <Box style={{ flexGrow: 1 }} />
        <Box
          spacing-xs={1}
          spacing-sm={2}
        >
          {shouldShowClientSelector && <ClientSelectorPopover />}
          {hasPermissionToShowMessages && <NotificationsPopover />}
          <LanguagePopover />
          <AccountPopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
